import React, { Component } from 'react';
import logo from '../assets/image/logoweb.png';
import '../css/Header.css';
import { _Alert, _get} from './Function';

class HeaderLogin extends Component {
	constructor() {
		super();
		this.BaseUrl = "https://www.srusct.or.th";
		this.state = {
			menus:[]
		};

		this.getHeaderMenus();
	}

	getHeaderMenus() {
		_get('get.header.menus.php').then(res => {
			this.setState({ menus: res.data.menu1.header});
		}).catch(err => {
			_Alert('error');
		});
	}

	render() {
		const currentPath = window.location.pathname
		return (
			<div>
				<div className="fix-content">
					<div nav="top" className="nav-top col-md-8">
						<a className="nav-link" href={this.BaseUrl}><img className="nav-top-logo" src={logo} /></a>
					</div>
					<nav className="navbar navbar-expand-lg navbar-light">
						<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div className="collapse navbar-collapse" id="navbarNavDropdown">
							<ul className="navbar-nav">
								{this.state.menus.map((menu, index) => {
									console.log(menu)
									return {...menu.items.length > 0 ? (
										<li key={"navbar-nav-"+index}  className="nav-item dropdown">
										<a className="nav-link dropdown-toggle text-left" href={menu.menu_url} id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{menu.menu_title}</a>
											<div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
												{menu.items.map((item, sub_index) => {
													console.log(item)
													return <a key={"navbar-nav-"+index + "_" + sub_index} className="dropdown-item text-left" href={item.menu_url}>{item.menu_title}</a>
												})}
											</div>
										</li>)
									 : (<li key={index}  className="nav-item dropdown"><a className="nav-link text-left" href={menu.menu_url != '/' ? menu.menu_url : this.BaseUrl}>{menu.menu_title}</a></li>)}
								})}
							</ul>
						</div>
					</nav>
				</div>
				<div className="nav-dash nav-login">{(currentPath === '/online/register') ? 'สมัครใช้งาน' : 'เข้าสู่ระบบ'}</div>
			</div>
		);
	}
}
export default HeaderLogin;